
const Params = {
    LOAD_ELEVATOR_TYPES: {
        NO: 11,
        PASSENGER: 12,
        SERVICE: 13,
    },
    UNLOAD_ELEVATOR_TYPES: {
        NO: 14,
        PASSENGER: 15,
        SERVICE: 16,
    },
    PACKING: 1,
    LOADERS_PARAMS: {
        LOAD_LOADERS_COUNT: 56,
        UNLOAD_LOADERS_COUNT: 57,
        LOADERS: 11,
        LOAD_LOADERS: 50,
        UNLOAD_LOADERS: 51,
        LOAD_FLOOR: 12,
        UNLOAD_FLOOR: 13,
        LOAD_ELEVATOR: 14,
        UNLOAD_ELEVATOR: 15,
        LOAD_ELEVATOR_NOT_FIT: 16,
        UNLOAD_ELEVATOR_NOT_FIT: 17,
    },
    TRUCK_BODY_TYPE_OPEN: {
        BOARD: 40,
        SHALANDA: 45,
        OPEN_TOP: 55,
        TIPPER: 53,
        MANIPULATOR: 101,
    },
    ESCORT: 34,
    ROUND_TRIP: 37,
    TRUCK_BODY_TYPE_OPEN_ID: 24,
    TRUCK_BODY_TYPE_CLOSE_ID: 38,
    TRUCK_BODY_TYPE_TEMP_ID: 43,
    TRUCK_BODY_TYPE_OUTSIZED_ID: 44,
    TRUCK_BODY_TYPE_PASSENGER_ID: 45,
    TRUCK_BODY_TYPE_OTHER_ID: 46,
    LOAD_TYPE_ID: 25,
};

export default Params



// WEBPACK FOOTER //
// ./client/constants/Parameters.js